<template>
  <div class="form">
    <Transition name="fade" mode="out-in">
      <NFTBuyForm :initialData="initialData"></NFTBuyForm>
    </Transition>
  </div>
</template>
<script setup>
import { computed, onMounted, watch, shallowRef, ref } from "vue";
import { useTitle } from "@vueuse/core";

import { useGlobalStore } from "@/stores/globalStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";
import { useNFTDataStore } from "@/stores/forms/nftDataStore";

import useProgressBarActions from "@/composables/progress/useProgressBarActions";
import useCreateDefaultsFromApi from "@/composables/api/useCreateDefaultsFromApi";
import useCreateDefaultsFromUrl from "@/composables/api/useCreateDefaultsFromUrl";
import useOrderCreation from "@/composables/api/useOrderCreation";

import NFTBuyForm from "@/components/forms/NFTBuyForm.vue";

const { resetAllProgress } = useProgressBarActions();
const { checkApiForNFTOrder, isAnApiOrder } =
  useCreateDefaultsFromApi();
const { checkURLForNFTOrder, isAnUrlOrder } =
  useCreateDefaultsFromUrl();
const { defaultData } = useOrderCreation();
const orderStore = useOrderFormStore();
const globalStore = useGlobalStore();
const nftDataStore = useNFTDataStore();

const initialData = ref({});

// order defaults can come from the url or api for NFT order
const setDefaults = async () => {
  // Get payment before getting order
  await globalStore.fetchPayments();
  if (isAnApiOrder) {
    const merchDefaults = await checkApiForNFTOrder();
    return merchDefaults;
  }

  return checkURLForNFTOrder();
};

const setNftData = () => {
  if (isAnUrlOrder){
    nftDataStore.setNftData("name", initialData.value?.urlData?.name);
    nftDataStore.setNftData("collection", initialData.value?.urlData?.collectionName);
    nftDataStore.setNftData("image", initialData.value?.urlData?.image);
    nftDataStore.setNftData("video", initialData.value?.urlData?.video);
    return
  }
  nftDataStore.setNftData("name", initialData.value?.urlData?.meta_data?.nft?.name);
  nftDataStore.setNftData("collection", initialData.value?.urlData?.meta_data?.nft?.collection);
  switch (initialData.value?.urlData?.meta_data?.nft?.media?.type){
    case "image":
      nftDataStore.setNftData("image", initialData.value?.urlData?.meta_data?.nft?.media?.link);
      break;
    case "video":
      nftDataStore.setNftData("video", initialData.value?.urlData?.meta_data?.nft?.media?.link);
      break;
  }
}

onMounted(async () => {
  orderStore.setActiveMode("NFT-BUY")
  initialData.value = await setDefaults();
  setNftData();
  resetAllProgress();
  useTitle("Banxa - Buy NFT");
});
</script>
